import { BlogTypes } from 'ha/constants/BlogTypes';
import {
  BLOG_ADVERTISER,
  BLOG_COUNTRY,
  BLOG_TENANT,
  BLOG_CITY,
} from 'ha/constants/pageNames';

export function getBlogCategory(blogType?: BlogTypes) {
  switch (blogType) {
    case BlogTypes.ADVERTISER:
      return BLOG_ADVERTISER;
    case BlogTypes.TENANT:
      return BLOG_TENANT;
    case BlogTypes.COUNTRY:
      return BLOG_COUNTRY;
    case BlogTypes.CITY:
      return BLOG_CITY;
    default:
      return BLOG_TENANT;
  }
}
